module.exports = "\n  <router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layouts/clientes/clientes-layout.component.html
// module id = ./src/app/modules/layouts/clientes/clientes-layout.component.html
// module chunks = main